module.exports = __webpack_public_path__ + "assets/img/balance.8ed2977f.svg";